import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  ButtonGroup,
  Table,
} from "reactstrap";
import { Link } from "react-router-dom";

import BreadCrumb from "../../../Components/Common/BreadCrumb";


import CreditLogService from "../../../services/OrderingServices/CreditLogService";
// import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";

const CreditLogSummary = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(5); // default All
  const [filterText, setFilterText] = useState("");

  const dateRangeEnum = {
    OneDay: 1,
    OneWeek: 2,
    OneMonth: 3,
    ThreeMonths: 4,
    All: 5,
  };

  const fetchCreditLogs = async (range) => {
    try {
      setLoading(true);
      const response = await CreditLogService.getSummary(range);
      setData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  const handleDateRangeClick = (range) => {
    let enumValue = dateRangeEnum.All;
    switch (range) {
      case "all":
        enumValue = dateRangeEnum.All;
        break;
      case "OneDay":
        enumValue = dateRangeEnum.OneDay;
        break;
      case "OneWeek":
        enumValue = dateRangeEnum.OneWeek;
        break;
      case "OneMonth":
        enumValue = dateRangeEnum.OneMonth;
        break;
      case "ThreeMonths":
        enumValue = dateRangeEnum.ThreeMonths; // Assuming 3 months = ThreeMonths? adjust if needed
        break;
      default:
        enumValue = dateRangeEnum.All;
    }
    setSelectedDateRange(enumValue);
    fetchCreditLogs(enumValue);
  };

  // initial fetch
  useEffect(() => {
    fetchCreditLogs(selectedDateRange);
  }, []);

  const filteredData = data.filter((pkg) => {
    const searchContext = `${pkg?.orderId || ""}`.toLowerCase();
    return searchContext.includes(filterText.toLowerCase());
  });

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Credit Logs Summary List" pageTitle="Credit Logs Summary" />
      </div>

      <Row className="mb-3">
        <Col lg={12} className="text-md-end">
          <Button
            color="primary"
            className="me-2 mb-2"
            onClick={() => handleDateRangeClick("all")}
          >
            All
          </Button>
          <Button
            color="info"
            className="me-2 mb-2"
            onClick={() => handleDateRangeClick("OneDay")}
          >
            One Day
          </Button>
          <Button
            color="info"
            className="me-2 mb-2"
            onClick={() => handleDateRangeClick("OneWeek")}
          >
            Last Week
          </Button>
          <Button
            color="warning"
            className="me-2 mb-2"
            onClick={() => handleDateRangeClick("OneMonth")}
          >
            Last 1 Month
          </Button>
          <Button
            color="danger mb-2"
            onClick={() => handleDateRangeClick("ThreeMonths")}
          >
            Last 3 Months
          </Button>
        </Col>
      </Row>
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-content-center align-items-center">
            {filteredData.length > 0 && (
              <h5>
                Balanced Amount:{" "}
                <strong>
                  <NumberWithCommas
                    number={filteredData
                      .filter((t) => t.totalRemaining > 0)
                      .reduce((sum, t) => sum + t.totalRemaining, 0)}
                  />
                </strong>
              </h5>
            )}
          </div>
          <Row>
            <div className="table-responsive">
              <Table bordered hover className="mb-0 table-nowrap ">
                <thead className="bg-light">
                  <tr>
                    <th>S.N</th>
                    <th>Customer Name</th>

                    <th className="text-end">Balanced Amt</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length > 0 ? (
                    filteredData.map((item, index) => (
                      <tr key={item.id || index}>
                        <td className="fs-6">{index + 1}</td>
                        <td className="fs-6">
                          <Link to={`/credit-logs/customer/${item?.customerId}`}>
                            {item.customerName}
                          </Link>
                        </td>

                        <td className="text-end fs-6 fw-bold">
                          {item.totalRemaining !== null &&
                          item.totalRemaining !== undefined &&
                          item.totalRemaining !== 0 ? (
                            <NumberWithCommas number={item.totalRemaining} />
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center">
                        No credit by customer
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot className="font-weight-bold">
                  <tr>
                    <td colSpan="1" className="text-end fw-bold">
                      Total
                    </td>
                    <td className="text-end fw-bold text-success"></td>
                    <td className="text-end fw-bold text-success">
                      <NumberWithCommas
                        number={filteredData
                          .filter((t) => t.totalRemaining > 0)
                          .reduce((sum, t) => sum + t.totalRemaining, 0)}
                      />
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default CreditLogSummary;
